import React, { PropsWithChildren, type FC } from "react";
import classes from "./BackgroundWatchlist.module.css";

type BackgroundWatchlistPropType = PropsWithChildren<{}>;

const BackgroundWatchlist: FC<BackgroundWatchlistPropType> = ({ children }) => {
  return (
    <div className={`${classes.background_wrapper}`}>
      <div className={`${classes.wrapper}`}>{children}</div>
    </div>
  );
};

export default BackgroundWatchlist;
